import React, {Dispatch, SetStateAction, useContext, useEffect, useState, useMemo} from "react";
import {Button, Grid} from "@mui/material";
import Card from "../../Components/Card";
import ResourceTable, {IGenerateColumns} from "../../Components/ResourceTable";
import {ean, eanRegistros} from "../../Requests";
import useGlobalContext from "../../Hooks/useGlobalContext";
import getInitialDataFilter from "../../Components/PageFilters/initialDataFilter";
import EanPageFilter from "../../Components/PageFilters/EanPageFilter";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import PreserveEan from "./PreserveEan";
import RemoveEan from "./RemoveEan";

const Ean: React.FC = () => {

    const {setLoading: setLoadingGlobal} = useGlobalContext();

    const [rechargeRequest, setRechargeRequest] = useState<number>(0);
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [idEanRemove, setIdEanRemove] = useState<number>(0);
    
    const reloadResourceTable = () => {
        setRechargeRequest(n => n + 1);
    }

    const { setFilters } = useGlobalContext();
    const { filters } = useGlobalContext();

    const actionViewDelete = (setLoading: Dispatch<SetStateAction<boolean>>) => async (id: number) => {
        setIdEanRemove(id);
    }

    const openModalNewEan = () => {
        setOpenModal(true);
    }

    useEffect(() => {
        if (setFilters) {
            setFilters(getInitialDataFilter());
        }
    }, []);

    const estruturaFilters = useMemo(() => {
        return {
          page: 1, // ou use o page do seu próprio estado de paginação
          recordsPerPage: 15, // idem
          ...filters, // aqui entram os filtros do contexto atualizados com `runFilters`
        };
      }, [filters]);

    const generateColumns: IGenerateColumns = ({setLoading}) => {
        return [
            {field: 'name', headerName: 'Nome do Arquivo', minWidth: 250, flex: 3},
            {field: 'username', headerName: 'Importado Por', minWidth: 250, flex: 3},
            {field: 'created_at', headerName: 'Data de Importação', minWidth: 250, flex: 3},
            {field: 'status', headerName: 'Status da Importação', minWidth: 250, flex: 3},
            {
                field: 'acao_remover',
                headerName: 'Remover',
                align: 'center',
                headerAlign: 'center',
                flex: 2,
                renderCell: (params: any) => {
                    const status = params?.row?.status;
                    
                    if (status === "Realizando importação") {
                        return "---";
                    }
            
                    return (
                        <div
                            style={{ cursor: 'pointer' }}
                            onClick={() => actionViewDelete(setLoading)(params?.row?.identifier || '')}
                        >
                            <DeleteForeverIcon sx={{ color: '#dc3545' }} />
                        </div>
                    );
                }
            }
            
        ];

    }

    const generateColumnsRegistros: IGenerateColumns = ({setLoading}) => {
        return [
            {field: 'codigo', type: 'number', headerName: 'Código', flex: 1},
            {field: 'descricao_completa', headerName: 'Descrição', minWidth: 250, flex: 2},
            {field: 'ncm', type: 'number',  headerName: 'NCM', flex: 3},
            {field: 'cest', type: 'number',  headerName: 'CEST', flex: 4},
            {field: 'pis_cofins', type: 'number',  headerName: 'PIS E COFINS', flex: 5},
            {field: 'nri', type: 'number',  headerName: 'NRI', flex: 6},
            {field: 'cst_icms', type: 'number',  headerName: 'CST ICMS | CSOSN', flex: 7},
            {field: 'ad_rem_icms', type: 'number',  headerName: 'AD REM ICMS', flex: 8},
            {field: 'icms', type: 'number',  headerName: 'ICMS (%)', flex: 9},
            {field: 'reducao_icms', type: 'number',  headerName: 'REDUÇÃO ICMS (%)', flex: 10},
            {field: 'icms_pdv', type: 'number',  headerName: 'ICMS PDV (%)',  flex: 11},
            {field: 'iva', type: 'number',  headerName: 'IVA', flex: 12},
            {field: 'amparo_legal', headerName: 'AMPARO LEGAL', flex: 13}
        ];
    }



    return (<>
        <Grid container spacing={0.5}>
            <EanPageFilter />
                <Grid item xs={12} md={12} lg={12} display='flex' justifyContent='flex-end'>
                                <Button variant="contained" sx={{backgroundColor: '#1c2e4a', color: '#FFF'}}
                                        onClick={openModalNewEan}>
                                    <AddCircleIcon
                                        sx={{
                                            marginRight: '5px',
                                            marginBottom: '2px',
                                            // color: '#777777',
                                            alignItems: 'baseline'
                                        }}
                                    /> Importar
                                </Button>

                                <PreserveEan
                                    reloadResourceTable={reloadResourceTable} openModal={openModal} setOpenModal={setOpenModal}
                                />
                            </Grid>
                            <Card
                                titleDashboard='Listagem de Importações de arquivos da tabela EAN'
                                icon='CloudUploadIcon'
                                paperConfig={{minHeight: 154}}
                                marginTop='0'
                                lineDividerHeader={false}
                            >
                                {/*{(accessProfilesOptions.length > 0) && */}
                                <ResourceTable
                                    request={ean}
                                    generateColumns={generateColumns}
                                    pageSizeOptions={[15]}
                                    getRowId={(row) => row?.identifier}
                                    minHeight={60}
                                    rechargeRequest={rechargeRequest}
                                    autoPageSize={true}
                                    filterDefinitions={({page,recordsPerPage}) => ({page,recordsPerPage})}
                                />
                                {/*}*/}
                            </Card>
                            {(idEanRemove > 0) && <RemoveEan
                                idEan={idEanRemove}
                                reloadResourceTable={reloadResourceTable}
                                close={() => setIdEanRemove(0)}
                            />}

            <Card
                titleDashboard='Listagem de Produtos com código de Barras - EANs | Base Elevate'
                icon='CloudUploadIcon'
                paperConfig={{minHeight: 154}}
                marginTop='0'
                lineDividerHeader={false}
            >
                {/*{(accessProfilesOptions.length > 0) && */}
                <ResourceTable
                    request={eanRegistros}
                    generateColumns={generateColumnsRegistros}
                    pageSizeOptions={[15]}
                    getRowId={(row) => row?.identifier}
                    minHeight={60}
                    rechargeRequest={rechargeRequest}
                    autoPageSize={true}
                    filterDefinitions={() => estruturaFilters}
                />
                {/*}*/}
            </Card>

        </Grid>
    </>);
}


export default Ean;
